const HiddenFrame = () => {
  return (
    <iframe
      name='hiddenFrame'
      title='hiddenFrame'
      style={{ display: 'none' }}
    />
  );
};

export default HiddenFrame;
